// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "build/js/" + chunkId + "." + "4cae06f2fbb01a977e72" + ".js";
};